export default "__VITE_ASSET__dvm0gzgz__"